import React from 'react'
import { formatRiskScoreNumber } from '../../../../components/patron/riskScoreMeta'

const STAGE_LABELS = {
  fresh: 'Fresh',
  investigated: 'Investigated',
  reported: 'Reported',
  prohibited: 'Prohibited',
}

function riskColor(level) {
  const l = String(level || '').toUpperCase()
  if (l === 'CRITICAL' || l === 'HIGH') return '#b91c1c'
  if (l === 'MEDIUM') return '#b45309'
  if (l === 'LOW') return '#047857'
  return '#334155'
}

function dvsColor(status) {
  const s = String(status || '').toUpperCase()
  if (s === 'VERIFIED' || s === 'READY') return '#047857'
  if (s === 'FAILED' || s === 'REJECTED') return '#b91c1c'
  if (s === 'PENDING') return '#b45309'
  return '#64748b'
}

function screeningColor(status) {
  const s = String(status || '').toUpperCase()
  if (s === 'CLEAR' || s === 'N/A') return '#047857'
  if (s === 'PEP' || s === 'MATCH') return '#b91c1c'
  return '#b45309'
}

export default function ProfileSummaryCards({
  complianceStage,
  cddTier,
  effectiveRisk,
  openCaseLabel,
  dvsStatus,
  dvsSubtitle,
  amlStatus,
  amlSubtitle,
}) {
  const stage = STAGE_LABELS[String(complianceStage || 'fresh').toLowerCase()] || 'Fresh'
  const cdd = cddTier ? String(cddTier).replace(/_/g, ' ') : null

  const cards = [
    {
      key: 'service',
      label: 'Service',
      border: 'border-l-green-500',
      value: cdd ? `${cdd} CDD` : stage,
      valueColor: '#047857',
      sub: cdd ? `${stage} · compliance stage` : 'No CDD tier on file',
    },
    {
      key: 'risk',
      label: 'Risk',
      border: 'border-l-amber-500',
      value: `${effectiveRisk?.level || '—'} · ${formatRiskScoreNumber(effectiveRisk?.score)}`,
      valueColor: riskColor(effectiveRisk?.level),
      sub: openCaseLabel || 'No open investigations',
    },
    {
      key: 'kyc',
      label: 'DVS / identity',
      border: 'border-l-red-500',
      value: dvsStatus || 'Unknown',
      valueColor: dvsColor(dvsStatus),
      sub: dvsSubtitle || '—',
    },
    {
      key: 'screening',
      label: 'Screening',
      border: 'border-l-amber-500',
      value: amlStatus || 'N/A',
      valueColor: screeningColor(amlStatus),
      sub: amlSubtitle || '—',
    },
  ]

  return (
    <div className="grid grid-cols-4 gap-3 px-6 py-4 bg-slate-100 border-b border-slate-200 max-xl:grid-cols-2">
      {cards.map((card) => (
        <div
          key={card.key}
          className={`bg-white border border-slate-200 rounded-[10px] shadow-sm px-4 py-3.5 border-l-4 ${card.border}`}
        >
          <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1.5">
            {card.label}
          </div>
          <div className="text-lg font-bold mb-1" style={{ color: card.valueColor }}>
            {card.value}
          </div>
          <div className="text-xs text-slate-500">{card.sub}</div>
        </div>
      ))}
    </div>
  )
}
